import apiService from "./apiService";
import AppConstants from "../appConstants";

class SendLeadService {
    getall(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_SENDLEAD, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    getTotalLeads(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_TOTAL_SENDLEAD, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getReportByDate(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_LEADS_REPORT_DATE, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadFile(AppConstants.URL_SENDLEAD_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    
    // =====================================================================
    
}

export default new SendLeadService();
